import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="client-form"
export default class extends Controller {
  lockCarNumberInput() {
    const input = document.querySelector("input#car_number");
    input.setAttribute("disabled", "");
  }
}
